export default function CountryFlag(props) {
	return (
		<img
			className={`inline-block ${props.className}`}
			src={`/icons/flags/${props.country}.svg`}></img>
	)
}
